import React, { useState, useEffect } from 'react';
import { Collapse } from 'react-bootstrap';
import { AiFillCaretDown } from 'react-icons/ai';
import { useHistory } from 'react-router-dom';

const languages = [
    { code: 'ko', label: '한국어', path: '/' },
    { code: 'en', label: 'English', path: '/en/home' },
    { code: 'vi', label: 'Việt Nam', path: '/vi/private-cloud#cluster' }
];

const LanguageSwitcher = () => {
    const history = useHistory();
    const [open, setOpen] = useState(false);
    const [currentLang, setCurrentLang] = useState('ko');

    useEffect(() => {
        const savedLang = localStorage.getItem('language');
        if (savedLang && languages.some(lang => lang.code === savedLang)) {
            setCurrentLang(savedLang);
        }
    }, []);

    const handleLanguageChange = (langCode, path) => {
        setCurrentLang(langCode);
        localStorage.setItem('language', langCode);
        setOpen(false);
        history.push(path);
    };

    const current = languages.find(lang => lang.code === currentLang);
    const others = languages.filter(lang => lang.code !== currentLang);

    return (
        <div
            className="item-nav-2"
            onClick={() => setOpen(!open)}
            aria-controls="language-collapse"
            aria-expanded={open}
        >
            <span className="navbar-link">
                {current.label} <AiFillCaretDown fontSize={10} />
            </span>
            <Collapse in={open}>
                <div id="language-collapse" className="English">
                    {others.map(lang => (
                        <div key={lang.code} onClick={() => handleLanguageChange(lang.code, lang.path)}>
                            {lang.label}
                        </div>
                    ))}
                </div>
            </Collapse>
        </div>
    );
};

export default LanguageSwitcher;
